import { useTranslation } from 'react-i18next'

import { Divider, EmptyView, Trans } from '@/components'
import { Instance } from '@/models/instance'

interface InstanceDatadriveProps {
  instance: Instance
}

export function InstanceDatadrive({ instance }: InstanceDatadriveProps) {
  const { t } = useTranslation()

  const personalMounts = instance.mountInfos ?? []
  const teamMounts = instance.teamMountInfos ?? []
  const hasNoMounts = personalMounts.length === 0 && teamMounts.length === 0

  if (hasNoMounts) {
    return (
      <div className="bg-panel-gray-100 rounded-lg text-center text-secondary">
        <EmptyView
          title={
            <span className="t-sm text-secondary">
              <Trans i18nKey="common.emptyViewNoDataMsg" />
            </span>
          }
        />
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4 bg-panel-gray-100 rounded-lg p-4">
      {personalMounts.length > 0 && (
        <div className="t-xs">
          <div className="mb-4 w-full text-tertiary flex space-x-2 items-center overflow-hidden">
            <div className="text-nowrap">
              <Trans i18nKey="instance.detail.datadrive.personal">Personal Datadrive</Trans>
            </div>
            <Divider className="my-0" />
          </div>

          <div className="flex flex-wrap gap-y-4">
            {personalMounts.map((mount, idx) => (
              <div key={`personal-${idx}`} className="flex flex-wrap gap-y-4 w-full">
                <div className="w-1/2">
                  <div className="t-xs text-secondary">
                    <Trans i18nKey="instance.detail.datadrive.mountPath">Mount Path</Trans>
                  </div>
                  <div className="t-sb">{mount.dest}</div>
                </div>
                <div className="w-1/2">
                  <div className="t-xs text-secondary">
                    <Trans i18nKey="instance.detail.datadrive.permissions">Permissions</Trans>
                  </div>
                  <div className="t-sb">
                    {mount.readOnly
                      ? t('instance.detail.datadrive.readOnly')
                      : t('instance.detail.datadrive.readWrite')}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {teamMounts.length > 0 && (
        <div className="t-xs">
          <div className="mb-4 w-full t-xs text-tertiary flex space-x-2 items-center overflow-hidden">
            <div className="text-nowrap">
              <Trans i18nKey="instance.detail.datadrive.team">Team Datadrive</Trans>
            </div>
            <Divider className="my-0" />
          </div>

          {/*<div className="text-secondary mb-2">{t('instance.detail.datadrive.team')}</div>*/}
          <div className="flex flex-wrap gap-y-4">
            {teamMounts.map((mount, idx) => (
              <div key={`team-${idx}`} className="flex flex-wrap gap-y-4 w-full">
                <div className="w-1/2">
                  <div className="t-xs text-secondary">
                    <Trans i18nKey="instance.detail.datadrive.mountPath">Mount Path</Trans>
                  </div>
                  <div className="t-sb">{mount.dest}</div>
                </div>
                <div className="w-1/2">
                  <div className="t-xs text-secondary">
                    <Trans i18nKey="instance.detail.datadrive.permissions">Permissions</Trans>
                  </div>
                  <div className="t-sb">
                    {mount.readOnly
                      ? t('instance.detail.datadrive.readOnly')
                      : t('instance.detail.datadrive.readWrite')}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
